module.exports = __webpack_public_path__ + "img/julia-dominguez-perrone-byn.f3b51c08.jpg";